import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

const footerLinks = {
  explore: [
    { label: 'Home', to: '/' },
    { label: 'Complete Guide', to: '/what-is-superbuy-spreadsheet' },
    { label: 'Shoes Guide', to: '/article/shoes-guide' },
    { label: 'Safety Guide', to: '/article/safety-guide' },
    { label: 'Beginner Guide', to: '/article/beginner-guide' },
    { label: 'Superbuy Sheet', href: mainSiteUrl, external: true },
    { label: 'Buy It Now', href: mainSiteUrl, external: true },
  ],
  categories: [
    { label: 'Shoes', href: 'https://kaspreadsheet.com/category-911-Shoes.html', external: true },
    { label: 'Hoodies/Sweaters', href: 'https://kaspreadsheet.com/search-912/name/Shoes.html', external: true },
    { label: 'Jackets', href: 'https://kaspreadsheet.com/search-914/name/Shoes.html', external: true },
    { label: 'Bags', href: 'https://kaspreadsheet.com/search-921/name/Shoes.html', external: true },
    { label: 'Accessories', href: 'https://kaspreadsheet.com/search-920/name/Shoes.html', external: true },
  ],
  resources: [
    { label: 'Shopping Guide', to: '/what-is-superbuy-spreadsheet' },
    { label: 'Shoes Finds', to: '/article/shoes-guide' },
    { label: 'Safety Tips', to: '/article/safety-guide' },
    { label: 'Beginner Start', to: '/article/beginner-guide' },
    { label: 'Blog', href: mainSiteUrl, external: true },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-file-list-3-line"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                Superbuy <span className="text-primary-400">Spreadsheet</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              The ultimate resource hub for international shoppers. Discover organized product
              categories, buying guides, and expert recommendations all in one place.
            </p>
          </div>

          {/* Explore */}
          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
              Explore
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.explore.map((link) =>
                link.external ? (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ) : (
                  <li key={link.label}>
                    <Link
                      to={link.to!}
                      className="text-sm text-foreground-300 hover:text-background-50 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
              Top Categories
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
              Resources
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.resources.map((link) =>
                link.external ? (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ) : (
                  <li key={link.label}>
                    <Link
                      to={link.to!}
                      className="text-sm text-foreground-300 hover:text-background-50 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>
        </div>
      </div>

      {/* Big Brand Text */}
      <div className="border-t border-foreground-800/30 py-12 overflow-hidden">
        <div className="font-heading text-4xl md:text-6xl lg:text-8xl font-bold text-foreground-700/15 text-center whitespace-nowrap tracking-tight select-none">
          SUPERBUY SPREADSHEET
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-foreground-800/30">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Superbuy Spreadsheet. All rights reserved.
          </p>
          <p className="text-xs text-foreground-500">
            A resource hub for international shoppers. Not affiliated with any specific platform.
          </p>
        </div>
      </div>
    </footer>
  );
}